import { useState, useEffect } from "react";
import { X, Save, Percent, Banknote, RefreshCw, AlertCircle } from "lucide-react";
export default function PromoCreateModal({ open, onClose, onSubmit, loading }) {
  const [formData, setFormData] = useState({
    code: "",
    type: "percentage",
    value: "",
    startDate: "",
    endDate: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setFormData({ code: "", type: "percentage", value: "", startDate: "", endDate: "" });
      setErrors({});
    }
  }, [open]);

 
  const generateCode = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(chars.length * Math.random()));
    }
    setFormData({ ...formData, code: result });
  };

  useEffect(() => {
    let newErrors = {};
    
    if (formData.type === "percentage" && formData.value > 100) {
      newErrors.value = "Le pourcentage ne peut pas dépasser 100%";
    }
    
    if (formData.startDate && formData.endDate) {
      if (new Date(formData.endDate) <= new Date(formData.startDate)) {
        newErrors.endDate = "La date de fin doit être après la date de début";
      }
    }

    setErrors(newErrors);
  }, [formData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Object.keys(errors).length > 0) return;

    const payload = {
      code: formData.code.toUpperCase(),
      startDate: formData.startDate,
      endDate: formData.endDate,
      [formData.type === "percentage" ? "percentage" : "amount"]: formData.value,
    };
    onSubmit(payload);
  };

  const canSubmit = 
    formData.code && 
    formData.value && 
    formData.startDate && 
    formData.endDate && 
    Object.keys(errors).length === 0;
  
  if (!open) return null;
  return (
    <div className="modalOverlay-Modern" onClick={onClose}>
      <div className="modalCard-Modern" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader-Modern">
          <h3>Nouvelle Promotion</h3>
          <button className="modalCloseModern" onClick={onClose}><X size={20} /></button>
        </div>

        <form onSubmit={handleSubmit} className="modalForm-Modern">
        
          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Code Promo</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                className="formInput-Modern"
                style={{ textTransform: 'uppercase', fontWeight: 'bold', flex: 1 }}
                value={formData.code}
                onChange={(e) => setFormData({...formData, code: e.target.value})}
                placeholder="EX: PROMO2"
                required
                max={6}
                min={6}
              />
              <button 
                type="button" 
                onClick={generateCode}
                className="roleChip-Modern active" 
                style={{ borderRadius: '10px', height: '46px' }}
                title="Générer un code"
              >
                <RefreshCw size={18} />
              </button>
            </div>
          </div>

          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Type de réduction</label>
            <div className="roleChipsContainer-Modern">
              <div
                className={`roleChip-Modern ${formData.type === "percentage" ? "active" : ""}`}
                onClick={() => setFormData({...formData, type: "percentage", value: ""})}
              >
                <Percent size={16} /> Pourcentage
              </div>
              <div
                className={`roleChip-Modern ${formData.type === "amount" ? "active" : ""}`}
                onClick={() => setFormData({...formData, type: "amount", value: ""})}
              >
                <Banknote size={16} /> Montant Fixe
              </div>
            </div>
          </div>


          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Montant</label>
            <input
              
              type="number"
              className={`formInput-Modern ${errors.value ? 'error' : ''}`}
              value={formData.value}
              onChange={(e) => setFormData({...formData, value: e.target.value})}
              placeholder={formData.type === "percentage" ? "Ex: 15%" : "Ex: 2000 CFA"}
              required
            />
            {errors.value && <div className="errorMsg"><AlertCircle size={14} /> {errors.value}</div>}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div className="formGroup-Modern">
              <label className="formLabel-Modern">Début</label>
              <input
                type="datetime-local"
                className="formInput-Modern"
                value={formData.startDate}
                onChange={(e) => setFormData({...formData, startDate: e.target.value})}
                required
              />
            </div>
            <div className="formGroup-Modern">
              <label className="formLabel-Modern">Fin</label>
              <input
                type="datetime-local"
                className={`formInput-Modern ${errors.endDate ? 'error' : ''}`}
                value={formData.endDate}
                onChange={(e) => setFormData({...formData, endDate: e.target.value})}
                required
              />
            </div>
          </div>
          {errors.endDate && <div className="errorMsg" style={{ marginTop: '-15px', marginBottom: '15px' }}><AlertCircle size={14} /> {errors.endDate}</div>}

          <div className="modalFooter-Modern">
            <button
              type="submit"
              className="btnModernSend"
              disabled={loading || !canSubmit}
            >
              {loading ? "Enregistrement..." : <>Créer la promotion <Save size={16} /></>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}